module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Map/Position-fcb7e71a9114566c03254c4a51cda06f.svg";